<template>
  <div>
    <!-- Section Hero Start-->
    <section id="intro" class="intro-wrapper">
      <div class="intro">
        <div id="hero-content" class="col-sm-5">
          <div class="hero-title">
            <h1 class="mb-4 font-weight-bold text-uppercase">
              {{ $t('heroTitle1')}}
              <br />
              {{ $t('heroTitle2')}}
            </h1>
            <p class="hero-text">{{ $t('heroDescription') }}</p>
            <button
              v-scroll-to="'#program'"
              type="button"
              id="hero-btn"
              class="mt-5"
            >{{ $t('buttonHero') }}</button>
          </div>
        </div>
        <div class="col-md-7"></div>
      </div>
    </section>
    <!-- Section Hero End -->

    <section id="program">
      <div class="container">
        <!-- Section Priority Lender Program Start-->
        <div class="content-title">
          <h2 class="text-center text-uppercase">{{ $t('programTitle')}}</h2>
        </div>
        <div class="text-center my-5">
          <p>
            {{ $t('programDescription1') }}
            {{ $t('programDescription2') }}
          </p>
        </div>

        <div class="row">
          <div class="col-sm-5 offset-sm-1">
            <div class="benefit-wrapper d-flex justify-content-md-center">
              <div class="col-xs-1 yellow-rounded-number">
                <span>1</span>
              </div>
              <div class="col benefit-desc">{{ $t('benefit1') }}</div>
            </div>
          </div>
          <div class="col-sm-5">
            <div class="benefit-wrapper d-flex justify-content-md-center">
              <div class="col-xs-1 yellow-rounded-number">
                <span>2</span>
              </div>
              <div class="col benefit-desc">{{ $t('benefit2') }}</div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-sm-5 offset-sm-1">
            <div class="benefit-wrapper d-flex justify-content-md-center">
              <div class="col-xs-1 yellow-rounded-number">
                <span>3</span>
              </div>
              <div class="col benefit-desc">{{ $t('benefit3') }}</div>
            </div>
          </div>
          <div class="col-sm-5">
            <div class="benefit-wrapper d-flex justify-content-md-center">
              <div class="col-xs-1 yellow-rounded-number">
                <span>4</span>
              </div>
              <div class="col benefit-desc">{{ $t('benefit4') }}</div>
            </div>
          </div>
        </div>

        <!-- Section Priority Lender Program End-->
      </div>
    </section>

    <section id="benefit">
      <div class="container">
        <div class="row" style="padding-bottom: 50px;">
          <div class="col-sm-5">
            <img
              src="@/assets/images/calculator2.png"
              alt="calculator"
              class="mx-auto d-block"
              width="200px"
            />
          </div>
          <div class="col-sm-7">
            <h1 class="text-center">{{ $t('calculatorTitle') }}</h1>
            <div class="calculator-description">
              <p class="text-center mt-4">{{ $t('calculatorDescription') }}</p>
            </div>
            <router-link
              to="/calculate"
              tag="button"
              class="btn btn-danger mx-auto d-block mt-3"
            >{{ $t('calculatorButton') }}</router-link>
          </div>
        </div>
      </div>
    </section>

    <section id="register">
      <!-- <div class="container-fluid"> -->
      <div class="container">
        <div class="row row-register">
          <div class="col-sm-6">
            <h2>{{ $t('registerTitle') }}</h2>
            <br />
            <p>{{ $t('registerDescription') }}</p>
          </div>
          <div class="col-sm-6">
            <RegisterForm :includeTncModal="true" />
          </div>
        </div>
      </div>

      <!-- </div> -->
    </section>

    <section id="footer">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-2 mt-2">
            <p>GRADANA</p>
            <p>
              Jalan Panjang 8F
              <br />Kebon Jeruk
              <br />Jakarta Barat, Indonesia
            </p>
          </div>
          <div class="col-12 col-lg-3">
            <ul class="list-unsyled mt-5" style="padding-left:0px">
              <li class="list-unstyled">
                <a class="text-dark">Hubungi Kami</a>
                <br />
                <a href="mailto:admin@gradana.com?subject=mail">admin@gradana.com</a>
                <p>
                  <a
                    href="https://wa.me/628111899188"
                    style="text-decoration:none"
                    class="text-dark"
                  >0811-1899-188</a>
                  <br />Senin-Jumat 09.00-18.00
                </p>
              </li>
            </ul>
          </div>
          <div class="col-12 col-lg-2">
            <ul style="padding-left: 0px">
              <li class="list-unstyled mt-5">
                <a href="https://gradana.co.id/artikel" class="text-dark">Artikel</a>
              </li>
              <li class="list-unstyled">
                <a href="https://gradana.co.id/gradp" class="text-dark">GraDP</a>
              </li>
              <li class="list-unstyled">
                <a href="https://gradana.co.id/grasewa-grarenov" class="text-dark">GraSewa-GraRenov</a>
              </li>
              <!-- <li class="list-unstyled">
                <a href="#!" class="text-dark">Beri-Pinjaman</a>
              </li>-->
              <li class="list-unstyled">
                <a href="https://gradana.co.id/grakarya" class="text-dark">GraKarya</a>
              </li>
              <!-- <li class="list-unstyled">
                <a href="https://gradana.co.id/properti" class="text-dark">Property</a>
              </li>-->
            </ul>
          </div>
          <div class="col-12 col-lg-5 mt-4 footer-item">
            <p class="text-center">Terdaftar dan di awasi oleh:</p>
            <div class="row">
              <div class="col-lg-4 col-6">
                <img
                  src="@/assets/images/ojk.png"
                  alt="ojk"
                  style="max-width: 110px;"
                  class="mx-auto d-block"
                />
              </div>
              <div class="col-lg-2 col-6 text-center">
                <img src="@/assets/images/kominfo.png" alt="Kominfo" style="max-width: 50px;" />
              </div>
              <div class="col-lg-3 col-6 mt-3">
                <img
                  src="@/assets/images/logo_afpi.png"
                  alt="AFPI"
                  class="mx-auto d-block"
                  width="90"
                />
              </div>
              <div class="col-lg-2 col-6">
                <img
                  src="@/assets/images/logo_fintech_indonesia.png"
                  alt="fintech-indonesia"
                  class="mx-auto d-block"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid">
      <div class="row">
        <div class="col bg-dark text-white mt-5 pt-2 text-center copyright">
          <p>Copyright&#169; 2017 PT.Gradana Teknoruci Indonesia.All Rights</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.calculator-description {
  max-width: 350px;
  margin: 0 auto;
}
</style>

<script>
import RegisterForm from "@/components/RegisterForm.vue";

export default {
  name: "LandingPage",
  components: {
    RegisterForm
  },
  mounted: function() {
    if (this.$route.query.action === "verify-pendanaan" && this.$route.query.token) {
      this.$axios.post("/api/v1/priority/user/investments/verify-link-paid", {
        token: this.$route.query.token,
        action: "verify-pendanaan",
      })
      .then(res => {
        this.$swal({type: "success", text: "Ubah status pendanaan menjadi paid berhasil"});
      })
      .catch(err => {
        this.$swal({type: "warning", text: "Ubah status gagal, " + err});
      })
    }
  },
  methods: {
    openTncModal() {
      $("#tncModal").modal("show");
    }
  }
};
</script>
